import { environment } from 'src/environments/environment'
import { Encryptor } from './encryptor'

export function getEncryptor() {
	const encryptImp = new Encryptor(environment.public_key)
	const randomKey = encryptImp.getRandomStr(16)
	
	const a2V5 = encryptImp.encryptForRSA(randomKey)


	const encrypt = (str: string) => {
		return encryptImp.AESEncryption(randomKey, str)
	}

	const decrypt = (data: string) => {
		return encryptImp.AESDecrypt(randomKey, data)
	}

	const decryptWithKey = (data: string, key) => {
		return encryptImp.AESDecrypt(key, data)
	}

	return { decrypt, encrypt, encryptImp, a2V5, decryptWithKey, randomKey }
}
